import { schema as schemas } from 'normalizr'
import qs from 'qs'

import { CallApi } from '@signavio/kraken'

import compositeId from '../../../../compositeId'

import { DMNUpdateRevisionPayloadType } from '../../../../../types'

export const collection = 'dmnRevisionUpdate'

export const schema = new schemas.Entity(
  collection,
  {},
  {
    idAttribute: compositeId('workflowId', 'modelId', 'revisionId'),
  }
)

type CreateQueryT = {
  workflowId: string
  modelId: string
  revisionId: string
  decisionId: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (
    { workflowId, modelId, decisionId }: CreateQueryT,
    { revisionId, activity }: DMNUpdateRevisionPayloadType
  ) =>
    callApi(
      `${apiBase}/workflows/${workflowId}/actions/dmnUpdateRevision${qs.stringify(
        {
          type: 'dmn',
          modelId,
          revisionId,
          decisionId,
        },

        { addQueryPrefix: true }
      )}`,
      schema,
      {
        method: 'POST',
        body: activity,
      }
    )
